import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from '../shared/services/navigation.service';
import { dahsboardIcon } from '../core/enum';

@Component({
  selector: 'app-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss']
})
export class DashboardCardComponent {

  /** Title For Component */
  @Input() name = 'Price Recommendation'

  /** Link to Navigate */
  @Input() link:any = null

  /** Code */ 
  @Input() code:any = null

  @Output() click:any = new EventEmitter<void>();

  /** Dashboard Icon Link */
  image_link :any = dahsboardIcon;

  constructor(private router : Router){}

  /** Navigate Function for the Provided link */
  navigate(){
    if(this.link)
    {
      this.router.navigate([`/${this.link}`])
    }
  }

  handleClick() {
    this.click.emit();
  }
}
